import type { QueryClient } from "@tanstack/react-query";
import { apiFetch } from "./api";
import { grammarKeys, type GrammarList } from "./grammar";
import { progressKeys, type ProgressStats } from "./progress";
import { reviewsKeys, type ReviewCard } from "./reviews";
import { features } from "./features";

/**
 * Warm up the queries the Home page needs so the splash screen doubles as
 * data loading time. Queries use the exact same keys as the corresponding
 * hooks, so when Home mounts it reads straight from the React Query cache.
 *
 * Fire-and-forget: individual failures are swallowed (the hooks will retry
 * normally once the component mounts).
 */
export async function prefetchHomeData(qc: QueryClient): Promise<void> {
  await Promise.all([
    qc
      .prefetchQuery({
        queryKey: progressKeys.stats,
        queryFn: () => apiFetch<ProgressStats>("/progress/stats"),
      })
      .catch(() => undefined),
    qc
      .prefetchQuery({
        queryKey: reviewsKeys.queue({}),
        queryFn: () => apiFetch<ReviewCard[]>("/reviews/queue"),
      })
      .catch(() => undefined),
    features.grammarSection &&
      qc
        .prefetchQuery({
          queryKey: grammarKeys.list({}),
          queryFn: () => apiFetch<GrammarList>("/grammar?"),
        })
        .catch(() => undefined),
  ]);
}
